"use strict";

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFocusManager = exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));
var _react = require("react");
var _focusManager = require("./focusManager");
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var useFocusManager = exports.useFocusManager = function useFocusManager(managerProps, shouldAttach, ref) {
  var _useState = (0, _react.useState)(),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    focusManager = _useState2[0],
    setFocusManager = _useState2[1];
  var attachFocusManager = function attachFocusManager() {
    if (ref !== null && ref !== void 0 && ref.current && !focusManager) {
      setFocusManager(new _focusManager.FocusManager(_objectSpread({
        trapNode: ref === null || ref === void 0 ? void 0 : ref.current
      }, managerProps)));
    }
  };
  (0, _react.useEffect)(function () {
    if (shouldAttach) {
      attachFocusManager();
    } else {
      focusManager === null || focusManager === void 0 || focusManager.detach();
      setFocusManager();
    }
    return function () {
      focusManager === null || focusManager === void 0 || focusManager.detach();
    };
  }, [shouldAttach, ref === null || ref === void 0 ? void 0 : ref.current]);
};
var _default = exports.default = useFocusManager;